<template lang="pug">
  #contact
    v-container(fluid)
      v-form
        v-row
          v-col#top(xs=6 sm=6)
            h1.form-title2.accent-text Datos de contacto

        v-row.py-1(align="start" justify="space-between")
          v-col.pr-2(d-flex xs=12 sm=5)
            v-text-field(
            	label="Nombre"
            	v-model="contactName"
            )
          v-col.pr-2(d-flex xs=12 sm=6)
            v-select(
            	label="Parentesco con la víctima"
            	v-model="victimRelation"
            	:items="relationList"
            	return-object
            )
            v-text-field(
              v-if="victimRelation == 'Otra' && showOtherVictimRelation == true"
            	v-model="otherVictimRelation"
            	label="Especificar parentesco"
            )

        v-row.py-1(align="end" justify="space-between")
          v-col.pr-2(d-flex xs=12 sm=5)
            v-text-field(
            	label="Teléfono casa"
            	v-model="phone"
            )
          v-col.pr-2(d-flex xs=12 sm=6)
            v-text-field(
            	label="Celular"
            	v-model="cellphone"
            )

        v-row.py-1
          label.custom.mb-2 Fecha de asesoría
        v-row.py-1.attention-date
          v-col(d-flex xs=2 sm=2)
            v-select(
              label="Día"
            	v-model="attentionDateDay"
              :items="days"
            )
          v-col(d-flex xs=2 sm=2)
            v-select(
              label="Mes"
              v-model="attentionDateMonth"
              :items="months"
            )
          v-col(d-flex xs=3 sm=3)
            v-autocomplete(
              label="Año"
              v-model="attentionDateYear"
              :items="years"
            )

        v-row.py-1
          v-col(d-flex xs=12 sm=6)
            v-select(
              label="¿La entrevista será grabada?"
              v-model="recordedInterview"
              :items="recordedInterviewOpts"
            )

</template>

<script>
import * as _ from "lodash";

export default {
  name: "Contact",
  data() {
    return {
      relationList: [
        "Esposo",
        "Esposa",
        "Mamá",
        "Papá",
        "Hermana",
        "Hermano",
        "Abuelo",
        "Abuela",
        "Hijo",
        "Hija",
        "Otra"
      ],
      recordedInterviewOpts: [
        "Si",
        "No",
        "N/D"
      ]
    };
  },
  computed: {
    days() {
      return this.$store.state.days;
    },
    months() {
      return this.$store.state.months;
    },
    years() {
      return this.$store.state.years;
    },
    contactName: {
    	get() { 
    		return this.$store.state.record.contact.name;
    	},
    	set(value) {
    		this.$store.state.record.contact.name = value;
    	}
    },
    victimRelation: {
      get() { 
    		return this.$store.state.record.contact.victimRelation;
    	},
    	set(value) {
    		this.$store.state.record.contact.victimRelation = value;
    	}
    },
    otherVictimRelation: {
      get() { 
    		return this.$store.state.record.contact.otherVictimRelation;
    	},
    	set(value) {
    		this.$store.state.record.contact.otherVictimRelation = value;
    	}
    },
    showOtherVictimRelation() {
      if (this.victimRelation !== "Otra") this.otherVictimRelation = "";
      return this.victimRelation == "Otra" ? true : false;
    },
    phone: {
    	get() { 
    		return this.$store.state.record.contact.phone;
    	},
    	set(value) {
    		this.$store.state.record.contact.phone = value;
    	}
    },
    cellphone: {
    	get() { 
    		return this.$store.state.record.contact.cellphone;
    	},
    	set(value) {
    		this.$store.state.record.contact.cellphone = value;
    	}
    },
    attentionDateDay: {
    	get() { 
    		return this.$store.state.record.contact.cedehmAttentionDate.day;
    	},
    	set(value) {
    		this.$store.state.record.contact.cedehmAttentionDate.day = value;
    	}
    },
    attentionDateMonth: {
    	get() { 
    		return this.$store.state.record.contact.cedehmAttentionDate.month;
    	},
    	set(value) {
    		this.$store.state.record.contact.cedehmAttentionDate.month = value;
    	}
    },
    attentionDateYear: {
    	get() { 
    		return this.$store.state.record.contact.cedehmAttentionDate.year;
    	},
    	set(value) {
    		this.$store.state.record.contact.cedehmAttentionDate.year = value;
    	}
    },
    recordedInterview: {
    	get() { 
    		return this.$store.state.record.contact.recordedInterview;
    	},
    	set(value) {
    		this.$store.state.record.contact.recordedInterview = value;
    	}
    }
  },
  methods: {
    generateNumberRange(start, stop) {
      return Array.from(
        { length: stop },
        (_, i) => start + i
      );
    }
  }
};
</script>

<style scoped lang="scss">
.col {
  padding-top: 0px;
  padding-bottom: 0px;
  padding-left: 0px;
}

.attention-date .v-select {
  padding-top: 0px !important;
}
</style>
